import Core from "./core";

/**
 * Sets a cookie.
 *
 * @param name Name of the cookie.
 * @param value Value of the cookie.
 * @param slidingExpiryIntervalSecs max-age (in seconds) of the cookie.
 * @param domain Optional domain name. This is required to set a cookie at parent domain.
 * @param secure Optional. Specifies whether the secure attribute of the cookie should be set.
 */
const set = function set(
  name: string,
  value: any,
  slidingExpiryIntervalSecs: number,
  domain = "",
  secure = false
): void {
  let cookie = name + "=" + encodeURIComponent(value);

  if (slidingExpiryIntervalSecs) {
    cookie += `;max-age=${slidingExpiryIntervalSecs}`;
  }

  if (domain) {
    cookie += `;domain=${domain};path=/`;
  }

  if (secure) {
    cookie += `;secure`;
  }

  // window.document.cookie = cookie;
};

/**
 * Retrieves the value of a cookie.
 *
 * @param Name of the cookie.
 *
 * @returns The value of the cookie if it exists. Otherwise returns an empty string.
 */
const get = function get(name: string): string {
  const cookies: string = window.document.cookie;
  if (cookies.length !== 0) {
    // const cokkieValue: RegExpMatchArray | null = cookies.match(
    //   "[;]{0,1}[s]*" + name + "=([^;]*)"
    // );
    // if (cokkieValue) {
    //   if (Core.isNotNull(cokkieValue)) {
    //     return decodeURIComponent(cokkieValue[1]);
    //   }
    //   return "";
    // }
    return "";
  }
  return "";
};

/**
 * Erases a cookie.
 *
 * @param cookieName Name of the cookie.
 * @param domain Optional domain name. This is required to delete a cookie at parent domain.
 */
const erase = function erase(cookieName: string, domain = ""): void {
  const cookies: string[] = window.document.cookie.split(";");
  for (let i = 0; i < cookies.length; i++) {
    const cookie: string = cookies[i];
    const eqPos: number = cookie.indexOf("=");
    // const value: string = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    // const name: string = value.trim();
    // if (!Core.isEmpty(cookieName) && cookieName !== name) {
    //   continue;
    // }
    let updatedCookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
    if (domain) {
      updatedCookie += `;domain=${domain};path=/`;
    }
    // window.document.cookie = updatedCookie;
  }
};

export default {
  get,
  set,
  erase
};
